var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toast-ui-viewer',{staticClass:"wysiwyg-viewer",attrs:{"initial-value":_vm.value,"initial-edit-type":"markdown"}})}
var staticRenderFns = []

export { render, staticRenderFns }